var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 571,
    viewBox: "0 0 390 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 571,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 380.803 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 362.869 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 344.936 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 327.003 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 309.069 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 291.136 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 273.203 30.0469)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 380.803 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 362.869 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 344.936 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 327.003 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 309.069 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 291.136 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 273.203 47.9805)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 380.803 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 362.869 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 344.936 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 327.003 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 309.069 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 291.136 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.06923,
    cy: 2.06923,
    r: 2.06923,
    transform: "matrix(-1 0 0 1 273.203 65.9141)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 193.012 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 180.64 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 168.267 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 155.895 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 143.523 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 131.151 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 118.778 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 106.406 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 94.0336 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 193.012 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 180.639 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 168.267 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 155.895 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 143.523 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 131.15 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 118.778 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 106.406 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 94.0336 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 193.012 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 180.639 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 168.267 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 155.895 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 143.523 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 131.15 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 118.778 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 106.406 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 94.0336 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 82.543 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 70.1708 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 57.7982 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 45.4261 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 33.054 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 20.6818 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 8.3092 335.012)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 82.543 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 70.1707 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 57.7985 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 45.4261 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 33.054 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 20.6816 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 8.30933 347.383)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 82.543 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 70.1707 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 57.7985 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 45.4261 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 33.054 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 20.6816 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42757,
    cy: 1.42757,
    r: 1.42757,
    transform: "matrix(-1 0 0 1 8.30933 359.758)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.558 346.234H223.811V404.938H226.558V346.234Z",
    fill: "#0A1F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.971 346.152L251.028 355.065L254.971 363.979H224.091V346.152H254.971Z",
    fill: "#0A1F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.895 570.663C185.546 570.663 225.796 531.116 225.796 482.332C225.796 433.547 185.546 394 135.895 394C86.2441 394 45.9941 433.547 45.9941 482.332C45.9941 531.116 86.2441 570.663 135.895 570.663Z",
    fill: "#E54E3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.169 546.064C172.087 546.064 201.204 517.529 201.204 482.331C201.204 447.132 172.087 418.598 136.169 418.598C100.252 418.598 71.1348 447.132 71.1348 482.331C71.1348 517.529 100.252 546.064 136.169 546.064Z",
    fill: "#E54E3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.074 500.908C116.819 474.509 83.0516 473.709 66.7565 476.67C66.6735 468.777 60.5279 462.402 52.9534 462.402C48.7744 462.402 45.0348 464.345 42.5028 467.408C25.504 442.962 0.0888672 439.773 0.0888672 439.773V570.973H163.132C163.132 570.973 167.28 527.255 142.074 500.908Z",
    fill: "#F3F4F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 489.5L48.2799 526.037L102.183 490.647L208.597 571.002H0V489.5Z",
    fill: "#0A1F8F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M225.098 400.211L33.2314 570.986H331.933V511.76L225.098 400.211Z",
    fill: "#091B79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.116 400.211L267.065 570.986H303.594H390C325.609 504.294 289.507 466.903 225.116 400.211Z",
    fill: "#0A1F8F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 511.337L0.5 570.861H262.5L104.981 445.344L0 511.337Z",
    fill: "#0A1F8F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0888672 564.977L104.472 444.93L0.0888672 511.538V564.977Z",
    fill: "#091B79"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6395 514.83L46.2372 493.04L13.749 502.348L103.377 445.941L42.6395 514.83Z",
    fill: "#223286"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.644 444.93L175.511 501.336L139.822 489.871L137.805 508.67L108.397 492.172L90.1128 507.734L80 492.814L43.8018 513.818L104.644 444.93Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.109 400.211L163.696 454.874L194.215 443.38L200.281 465.347L223.739 445.981L243.825 479.365L225.109 400.211Z",
    fill: "#223286"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.96 477.839L258.011 448.996L270.437 447.335L225.116 400.211L243.96 477.839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuMobile);
export default __webpack_public_path__ + "static/media/auMobile.fd9debdadc33dda29fe6197be9cafeb6.svg";
export { ForwardRef as ReactComponent };